{
  "required": "This field is required",
  "email": "Enter a valid email address",
  "minLength": "Must be at least {{count}} characters",
  "maxLength": "Must be at most {{count}} characters",
  "passwordWeak": "Password is too weak",
  "passwordsMismatch": "Passwords do not match",
  "invalidNumber": "Value must be a number",
  "positiveNumber": "Value must be greater than zero",
  "requiredFieldsNote": "Required fields are marked with an asterisk",
  "numbersOnly": "Only numbers are allowed",
  "tooManyDecimals": "At most five decimal places are allowed."
}
